/**
 * PDP buy-box enhancements — bundle packs, matching closure, live totals.
 * Complements the existing variant/ATC form in product-template.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp-buy-box]');
  if (!root) return;

  var dataEl = root.querySelector('[data-pdp-buy-box-data]');
  if (!dataEl) return;

  var product;
  try {
    product = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var form = root.closest('form') || document.querySelector('form.product-form');
  var qtyInput = document.getElementById('Quantity');
  var qtyWrap = document.querySelector('.product-form__item--quantity');
  var packsEl = root.querySelector('[data-pdp-packs]');
  var stepperEl = root.querySelector('[data-pdp-stepper]');
  var stepperInput = root.querySelector('[data-pdp-qty-input]');
  var closureWrap = root.querySelector('[data-pdp-closure]');
  var closureToggle = root.querySelector('[data-pdp-closure-toggle]');
  var closureCheckLabel = root.querySelector('[data-pdp-closure-check-label]');
  var closureSelectWrap = root.querySelector('[data-pdp-closure-select-wrap]');
  var closureSelect = root.querySelector('[data-pdp-closure-select]');
  var totalEl = root.querySelector('[data-pdp-total]');
  var stockEl = root.querySelector('[data-pdp-stock]');
  var sectionId = (form && form.getAttribute('data-section')) || 'product-template';
  var variantSelect = document.getElementById('ProductSelect-' + sectionId);
  var comingSoon = root.getAttribute('data-launch-status') === 'coming_soon';
  var forceAtc = root.hasAttribute('data-launch-force-atc') || (form && form.hasAttribute('data-launch-force-atc'));
  if (document.documentElement.classList.contains('shh-burmese-live')) {
    comingSoon = false;
    forceAtc = true;
  }

  // Bundles use pack UI + custom stepper; hide the legacy qty field in the ATC row.
  if (product.is_bundle && qtyWrap) {
    qtyWrap.classList.add('pdp-buy-box__qty-stepper--hidden');
  }

  var state = {
    packMode: product.is_bundle ? '3' : 'other',
    closureEnabled: false,
    closureVariantId: null,
    closurePrice: 0,
    variantId: null,
    variantPrice: null,
    variantCompareAt: null,
    selectedLength: null
  };

  function stripMoneyHtml(value) {
    if (!value) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = String(value);
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined || isNaN(cents)) return '—';
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return stripMoneyHtml(theme.Currency.formatMoney(cents, theme.moneyFormat));
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return stripMoneyHtml(Shopify.formatMoney(cents, (theme && theme.moneyFormat) || '${{amount}}'));
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  // When sale prices are hidden, list compare-at as the unit price.
  function listedUnitPrice(priceCents, compareAtCents) {
    var revealSale = window.theme && theme.revealSalePrice === true;
    if (!revealSale && compareAtCents && compareAtCents > priceCents) return compareAtCents;
    return priceCents;
  }

  function parseLengthInches(value) {
    if (!value) return null;
    var match = String(value).match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1]) : null;
  }

  function getQty() {
    var source = (state.packMode === 'other' && stepperInput) ? stepperInput : qtyInput;
    if (!source) return 1;
    var qty = parseInt(source.value, 10);
    if (isNaN(qty) || qty < 1) return 1;
    return qty;
  }

  function setQty(value) {
    var qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    if (qtyInput) qtyInput.value = String(qty);
    if (stepperInput) stepperInput.value = String(qty);
  }

  function findVariantById(id) {
    id = parseInt(id, 10);
    return (product.variants || []).filter(function (v) { return v.id === id; })[0] || null;
  }

  function findVariantByLength(lengthValue) {
    var variants = product.variants || [];
    if (!lengthValue) {
      return findVariantById(variantSelect && variantSelect.value) || variants[0] || null;
    }
    var idx = product.length_option_index;
    var match;
    if (idx === null || idx === undefined) {
      match = variants.filter(function (v) {
        return v.title === lengthValue || v.option1 === lengthValue;
      });
    } else {
      var key = 'option' + (idx + 1);
      match = variants.filter(function (v) {
        return v[key] === lengthValue;
      });
    }
    return match[0] || null;
  }

  function getSelectedLength() {
    var checked = document.querySelector('.product-form .swatch input:checked, form.product-form .swatchInput:checked');
    if (checked) return checked.value;
    var variant = findVariantById(variantSelect && variantSelect.value);
    if (!variant) return null;
    var idx = product.length_option_index;
    if (idx === null || idx === undefined) return variant.title;
    return variant['option' + (idx + 1)] || null;
  }

  function findClosestClosureVariant(closure, targetLength) {
    if (!closure || !closure.variants || !closure.variants.length) return null;

    var idx = closure.length_option_index;
    var available = closure.variants.filter(function (v) { return v.available; });
    var pool = available.length ? available : closure.variants;

    if (idx === null || idx === undefined) return pool[0] || null;

    var key = 'option' + (idx + 1);
    var targetInches = parseLengthInches(targetLength);
    var exact = pool.filter(function (v) { return v[key] === targetLength; })[0];
    if (exact) return exact;
    if (targetInches == null) return pool[0] || null;

    var best = null;
    var bestDiff = Infinity;
    pool.forEach(function (v) {
      var inches = parseLengthInches(v[key]);
      if (inches == null) return;
      var diff = Math.abs(inches - targetInches);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = v;
      }
    });
    return best || pool[0] || null;
  }

  function getClosurePool(closure) {
    if (!closure || !closure.variants) return [];
    var available = closure.variants.filter(function (v) { return v.available; });
    return available.length ? available : closure.variants;
  }

  function getClosureLabel(variant, closure) {
    if (!variant) return closure.title || 'Closure';
    if (variant.title && variant.title !== 'Default Title') {
      return variant.title + ' — ' + formatMoney(variant.price);
    }
    return (closure.title || 'Closure') + ' — ' + formatMoney(variant.price);
  }

  function syncPackUI() {
    if (!product.is_bundle || !packsEl) return;

    Array.prototype.forEach.call(packsEl.querySelectorAll('[data-pdp-pack]'), function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-pdp-pack') === state.packMode);
    });

    if (stepperEl) {
      stepperEl.hidden = state.packMode !== 'other';
    }
  }

  function setPackMode(mode) {
    state.packMode = mode;
    if (mode === '2' || mode === '3') {
      setQty(mode);
    } else if (mode === 'other') {
      var current = getQty();
      if (current === 2 || current === 3 || current < 1) {
        setQty(1);
      } else {
        setQty(current);
      }
    }
    syncPackUI();
    updatePackPrices();
    updateTotal();
  }

  function updatePackPrices() {
    var unit = listedUnitPrice(state.variantPrice, state.variantCompareAt);
    Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-pack-price]'), function (el) {
      var qty = parseInt(el.getAttribute('data-pdp-pack-price'), 10);
      if (!unit || isNaN(qty)) {
        el.textContent = '';
        return;
      }
      el.textContent = formatMoney(unit * qty);
    });
  }

  function rebuildClosureOptions(preferMatch) {
    if (!closureWrap || !closureSelect) return;

    var closure = product.matching_closure;
    if (!closure || !closure.variants || !closure.variants.length) {
      closureWrap.hidden = true;
      return;
    }

    closureWrap.hidden = false;
    var pool = getClosurePool(closure);
    var matched = findClosestClosureVariant(closure, state.selectedLength);
    var selectedId = preferMatch && matched
      ? matched.id
      : (parseInt(closureSelect.value, 10) || (matched && matched.id) || (pool[0] && pool[0].id));

    var optionsHtml = '';
    pool.forEach(function (v) {
      optionsHtml +=
        '<option value="' + v.id + '"' +
        (selectedId === v.id ? ' selected' : '') +
        '>' + getClosureLabel(v, closure) + '</option>';
    });
    closureSelect.innerHTML = optionsHtml;
    syncClosureSelection();
  }

  function syncClosureSelection() {
    if (!closureWrap || !closureSelect) return;

    var closure = product.matching_closure;
    if (!closure) {
      state.closureVariantId = null;
      state.closurePrice = 0;
      return;
    }

    var pool = getClosurePool(closure);
    var matched = findClosestClosureVariant(closure, state.selectedLength);
    var selectedId = parseInt(closureSelect.value, 10);
    var selected = pool.filter(function (v) { return v.id === selectedId; })[0] || matched || pool[0];
    var labelVariant = selected || matched || pool[0];
    var basePrice = labelVariant ? labelVariant.price : closure.price || 0;

    if (closureCheckLabel) {
      closureCheckLabel.textContent = 'Add Closure + ' + formatMoney(basePrice);
    }

    if (state.closureEnabled) {
      if (closureSelectWrap) closureSelectWrap.hidden = false;
      state.closureVariantId = selected ? selected.id : null;
      state.closurePrice = selected ? selected.price : 0;
    } else {
      if (closureSelectWrap) closureSelectWrap.hidden = true;
      state.closureVariantId = null;
      state.closurePrice = 0;
    }
  }

  function notifyMeta() {
    var trigger = document.querySelector('.launch-notify-trigger[data-launch-notify]');
    return {
      handle: trigger && trigger.getAttribute('data-launch-handle'),
      title: trigger && trigger.getAttribute('data-launch-title'),
      url: trigger && trigger.getAttribute('data-launch-url'),
      mode: comingSoon ? 'coming_soon' : 'restock'
    };
  }

  function lengthNotifyEl() {
    return document.querySelector('.product-form [data-length-notify], form.product-form [data-length-notify]');
  }

  function unavailableVariantsForLength(lengthValue) {
    var variants = product.variants || [];
    var idx = product.length_option_index;
    return variants.filter(function (v) {
      if (v.available) return false;
      if (idx === null || idx === undefined) {
        return v.title === lengthValue || v.option1 === lengthValue;
      }
      return v['option' + (idx + 1)] === lengthValue;
    });
  }

  function hideUnderSwatchNotify() {
    var ctl = lengthNotifyEl();
    if (!ctl) return;
    ctl.hidden = true;
    ctl.removeAttribute('data-launch-variant');
    ctl.removeAttribute('data-launch-length');
  }

  function pdpStockLine() {
    return (stockEl && stockEl.querySelector('.stock-scarcity')) || stockEl;
  }

  function applyStockNotify(lengthValue, ids) {
    var line = pdpStockLine();
    if (!line) return;
    var meta = notifyMeta();
    stockEl.hidden = false;
    if (window.SHHStock && typeof SHHStock.applyNotifyFocus === 'function') {
      SHHStock.applyNotifyFocus(line, {
        length: lengthValue,
        variantIds: ids.join(','),
        handle: meta.handle,
        title: meta.title,
        url: meta.url,
        mode: meta.mode || 'restock'
      });
    }
  }

  function clearLengthNotifyFocus() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-form .swatch-element.is-notify-focus'), function (el) {
      el.classList.remove('is-notify-focus');
    });
    hideUnderSwatchNotify();
    if (window.SHHStock) updateStock();
  }

  function showLengthNotify(swatch) {
    var lengthValue = swatch.getAttribute('data-value') || '';
    var matches = unavailableVariantsForLength(lengthValue);
    var ids = matches.map(function (v) { return v.id; });
    if (!ids.length) {
      var fallback = swatch.getAttribute('data-variant-id');
      if (fallback) ids = [fallback];
    }
    Array.prototype.forEach.call(document.querySelectorAll('.product-form .swatch-element.is-notify-focus'), function (el) {
      el.classList.remove('is-notify-focus');
    });
    hideUnderSwatchNotify();
    swatch.classList.add('is-notify-focus');
    applyStockNotify(lengthValue, ids);
  }

  function interceptSoldoutSwatch(e) {
    if (comingSoon) return;
    if (e.target.closest('[data-length-notify], [data-pdp-stock][data-launch-notify], .stock-scarcity--notify-focus')) return;
    var swatch = e.target.closest('.swatch-element.soldout');
    if (!swatch || !swatch.closest('.product-form, form.product-form')) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    showLengthNotify(swatch);
  }

  function updateStock() {
    if (!stockEl) return;
    var line = pdpStockLine();
    var variant = findVariantById(state.variantId);
    if (forceAtc && (!variant || !variant.available)) {
      stockEl.hidden = true;
      return;
    }
    stockEl.hidden = false;
    if (!window.SHHStock) return;
    var result = SHHStock.resolve(variant, { surface: 'pdp', comingSoon: comingSoon && !forceAtc });
    SHHStock.apply(line, result, { notify: forceAtc ? null : notifyMeta() });
  }

  function getLineTotalCents() {
    if (state.variantPrice === null || state.variantPrice === undefined) return null;
    var unit = listedUnitPrice(state.variantPrice, state.variantCompareAt);
    var total = unit * getQty();
    if (state.closureEnabled && state.closurePrice) total += state.closurePrice;
    return total;
  }

  function updateCtaLabel() {
    var textEl = document.getElementById('AddToCartText-' + sectionId);
    var atcBtn = form && form.querySelector('[type="submit"][name="add"]');
    if (comingSoon) {
      publishLineTotal(null);
      document.dispatchEvent(new CustomEvent('pdp:ctaLabelChange'));
      return;
    }
    if (!textEl) return;

    if (atcBtn && (atcBtn.disabled || atcBtn.classList.contains('is-launch-hidden'))) {
      publishLineTotal(null);
      document.dispatchEvent(new CustomEvent('pdp:ctaLabelChange'));
      return;
    }

    var total = getLineTotalCents();
    var money = total != null ? formatMoney(total) : '';
    var qty = getQty();
    var base =
      (window.theme && theme.strings && theme.strings.addToCart) ||
      'Add to Bag';
    var label;

    if (product.is_bundle && qty >= 1 && money) {
      label = 'Add ' + qty + (qty === 1 ? ' Bundle' : ' Bundles') + ' — ' + money;
    } else if (money) {
      label = base + ' — ' + money;
    } else {
      label = base;
    }

    textEl.textContent = label;
    publishLineTotal(total);
    document.dispatchEvent(new CustomEvent('pdp:ctaLabelChange'));
  }

  /** Keep sticky ATC price on the same line total as the buy-box CTA. */
  function publishLineTotal(totalCents) {
    var money = totalCents != null ? formatMoney(totalCents) : '';
    var stickyPrice = document.querySelector('[data-pdp-sticky-price]');
    if (stickyPrice && money) {
      stickyPrice.textContent = money;
      stickyPrice.setAttribute('data-line-total', String(totalCents));
    }
    document.dispatchEvent(
      new CustomEvent('pdp:lineTotalChange', {
        detail: { cents: totalCents, money: money }
      })
    );
  }

  function updateTotal() {
    if (!totalEl) {
      updateCtaLabel();
      return;
    }
    var total = getLineTotalCents();
    if (total === null) {
      totalEl.hidden = true;
      updateCtaLabel();
      return;
    }
    totalEl.hidden = false;
    totalEl.innerHTML =
      '<span class="pdp-buy-box__total-label">Total</span>' +
      '<span class="pdp-buy-box__total-value">' + formatMoney(total) + '</span>';
    updateCtaLabel();
  }

  function syncFromVariant() {
    state.selectedLength = getSelectedLength();
    var variant = findVariantById(variantSelect && variantSelect.value);
    if (!variant && state.selectedLength) {
      variant = findVariantByLength(state.selectedLength);
    }
    if (!variant) {
      variant = (product.variants || [])[0] || null;
    }
    state.variantId = variant ? variant.id : null;
    state.variantPrice = variant ? variant.price : null;
    state.variantCompareAt = variant ? variant.compare_at_price : null;
    updatePackPrices();
    rebuildClosureOptions(true);
    updateStock();
    updateTotal();
  }

  function addClosureThenFinish(mainData, qty, done) {
    if (!state.closureEnabled || !state.closureVariantId || typeof CartJS === 'undefined') {
      done(mainData, qty);
      return;
    }
    if (theme.CartAdd && theme.CartAdd.addItem) {
      theme.CartAdd.addItem(state.closureVariantId, 1, {}, {
        surface: 'pdp_closure',
        success: function () { done(mainData, qty); },
        error: function () { done(mainData, qty); }
      });
      return;
    }
    CartJS.addItem(state.closureVariantId, 1, {}, {
      success: function () { done(mainData, qty); },
      error: function () { done(mainData, qty); }
    });
  }

  function interceptSubmit(e) {
    var atcBtn = form && form.querySelector('[type="submit"][name="add"]');
    if (comingSoon || (atcBtn && atcBtn.classList.contains('is-launch-hidden'))) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!state.closureEnabled || !state.closureVariantId) return;
    if (typeof CartJS === 'undefined' || !(theme && theme.ajax_cart)) return;

    e.preventDefault();
    e.stopPropagation();

    var qty = getQty();
    if (atcBtn) {
      if (atcBtn.disabled) return;
      atcBtn.disabled = true;
    }
    document.body.classList.add('loading');

    function finishOk(mainData, addedQty) {
      document.body.classList.remove('loading');
      if (atcBtn) atcBtn.disabled = false;
      if (window.theme && theme.CartDrawer && theme.CartDrawer.isEnabled) {
        theme.CartDrawer.showAdded(mainData, addedQty);
      } else {
        window.location.href = '/cart';
      }
    }

    function failMain(parsed, extra) {
      document.body.classList.remove('loading');
      if (atcBtn) atcBtn.disabled = false;
      if (theme.CartAdd && theme.CartAdd.presentError) {
        theme.CartAdd.presentError(parsed, extra);
        return;
      }
      window.alert((parsed && parsed.message) || 'Unable to add to cart');
    }

    var variantId = state.variantId || (variantSelect && variantSelect.value);
    if (theme.CartAdd && theme.CartAdd.addItem) {
      theme.CartAdd.addItem(variantId, qty, {}, {
        surface: 'pdp',
        success: function (data) {
          addClosureThenFinish(data, qty, finishOk);
        },
        error: failMain
      });
      return;
    }

    CartJS.addItem(variantId, qty, {}, {
      success: function (data) {
        addClosureThenFinish(data, qty, finishOk);
      },
      error: function (jqXHR) {
        var parsed = { message: '', retryable: true, status: 0 };
        try {
          parsed.message = JSON.parse(jqXHR.responseText).description || '';
        } catch (err) {}
        failMain(parsed, {});
      }
    });
  }

  // Events
  if (packsEl) {
    packsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pdp-pack]');
      if (!btn) return;
      e.preventDefault();
      setPackMode(btn.getAttribute('data-pdp-pack'));
    });
  }

  if (stepperEl) {
    stepperEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pdp-qty]');
      if (!btn) return;
      e.preventDefault();
      // Stay on "Other" — never snap back to 2/3 pack when qty hits those values.
      state.packMode = 'other';
      syncPackUI();
      var next = getQty();
      if (btn.getAttribute('data-pdp-qty') === 'plus') next += 1;
      else if (next > 1) next -= 1;
      setQty(next);
      updateTotal();
    });
  }

  if (stepperInput) {
    stepperInput.addEventListener('change', function () {
      state.packMode = 'other';
      syncPackUI();
      setQty(stepperInput.value);
      updateTotal();
    });
    stepperInput.addEventListener('input', function () {
      state.packMode = 'other';
      syncPackUI();
      if (qtyInput) qtyInput.value = stepperInput.value;
      updateTotal();
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', updateTotal);
    qtyInput.addEventListener('input', function () {
      if (product.is_bundle && state.packMode !== 'other') {
        state.packMode = 'other';
        syncPackUI();
      }
      updateTotal();
    });
  }

  // Keep totals in sync when legacy +/- buttons mutate qty (non-bundle products).
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.qtyBtn')) return;
    window.setTimeout(updateTotal, 0);
  });

  if (closureToggle) {
    closureToggle.addEventListener('change', function () {
      state.closureEnabled = !!closureToggle.checked;
      syncClosureSelection();
      updateTotal();
    });
  }

  if (closureSelect) {
    closureSelect.addEventListener('change', function () {
      syncClosureSelection();
      updateTotal();
    });
  }

  if (form) {
    form.addEventListener('submit', interceptSubmit, true);
  }

  document.addEventListener('click', interceptSoldoutSwatch, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product-form .swatch-element.available, form.product-form .swatch-element.available')) {
      clearLengthNotifyFocus();
    }
  });

  // Theme fires variant changes through the select / swatch radios
  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (
      e.target.matches('.swatchInput') ||
      e.target.classList.contains('swatchInput') ||
      e.target.matches('.single-option-selector-' + sectionId) ||
      e.target === variantSelect
    ) {
      window.setTimeout(syncFromVariant, 50);
      window.setTimeout(syncFromVariant, 200);
      // Theme resets ATC label on variantChange — re-apply after it.
      window.setTimeout(updateCtaLabel, 60);
      window.setTimeout(updateCtaLabel, 220);
    }
  });

  if (window.jQuery) {
    jQuery('.product-form .swatch :radio').on('change.pdpBuyBox', function () {
      window.setTimeout(syncFromVariant, 50);
      window.setTimeout(updateCtaLabel, 60);
    });
    jQuery('[data-section-type="product"], .product-template, #ProductSection-' + sectionId + ', .product-single').on('variantChange.pdpBuyBox', function (evt) {
      if (evt && evt.variant) {
        state.variantId = evt.variant.id;
        state.variantPrice = evt.variant.price;
        state.variantCompareAt = evt.variant.compare_at_price;
        state.selectedLength = getSelectedLength();
        updatePackPrices();
        rebuildClosureOptions(true);
        updateStock();
        updateTotal();
        window.setTimeout(updateCtaLabel, 0);
        return;
      }
      syncFromVariant();
      window.setTimeout(updateCtaLabel, 0);
    });
  }

  document.addEventListener('shh:burmese-live', function () {
    comingSoon = false;
    forceAtc = true;
    if (form) {
      form.removeAttribute('data-launch-status');
      form.setAttribute('data-launch-force-atc', '');
    }
    root.removeAttribute('data-launch-status');
    root.setAttribute('data-launch-force-atc', '');
    updateStock();
    updateCtaLabel();
  });

  // Init
  if (product.is_bundle) {
    setQty(3);
  }
  syncPackUI();
  syncFromVariant();
  if (!window.SHHStock) {
    window.setTimeout(function () {
      if (window.SHHStock) updateStock();
    }, 0);
  }
})();
